import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { StyledContentAreaRowWrapper, StyledRow, StyledColumn } from './styles'
import { Text, Title } from '../../atoms/text'
import { AuthContext } from '../../../context/authProvider'
import { LoggedInOutButton } from '../loggedInOutButton'
import { useEventTracking } from '../../../context/eventTrackingProvider'

const ContentAreaRow = (props) => {
  const {
    background_color,
    visibility_settings,
    text_fields,
    cta_logged_in,
    cta_logged_out,
  } = props.content

  const { isLoggedIn } = useContext(AuthContext)
  const { trackEvent, EVENT_NAMES, EVENT_LOCATIONS } = useEventTracking()

  const nonAllowedVisibility = isLoggedIn ? 'anonymous_only' : 'logged_in_only'
  if (visibility_settings == nonAllowedVisibility) return <></>

  return (
    <StyledContentAreaRowWrapper style={{ backgroundColor: background_color }}>
      <StyledRow>
        {text_fields.map((group, i) => (
          <StyledColumn key={`content-area-2-${i}`}>
            <Title textAlign="center" tagType={'span'}>
              {group.label}
            </Title>
            <Text textAlign="center">{group.content}</Text>
          </StyledColumn>
        ))}
      </StyledRow>
      <LoggedInOutButton
        loggedIn={cta_logged_in}
        loggedOut={cta_logged_out}
        eventId="content-area-row"
        onClick={() => {
          trackEvent(EVENT_NAMES.SIGNUP_STARTED,
             { location: EVENT_LOCATIONS.HOW_TO_START_SECTION }
          );
        }}
      />
    </StyledContentAreaRowWrapper>
  )
}
ContentAreaRow.defaultProps = {
  background_color: null,
  content: {
    text_fields: [],
    cta: [],
  },
}

ContentAreaRow.propTypes = {
  content: PropTypes.shape({
    background_color: PropTypes.string,
    visibility_settings: PropTypes.string,
    text_fields: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        content: PropTypes.string,
      })
    ).isRequired,
    cta_logged_in: PropTypes.arrayOf(
      PropTypes.shape({
        action_text: PropTypes.string,
        link: PropTypes.string,
      })
    ),
    cta_logged_out: PropTypes.arrayOf(
      PropTypes.shape({
        action_text: PropTypes.string,
        link: PropTypes.string,
      })
    ),
  }),
}

export { ContentAreaRow }
